import styled from "styled-components";
import { Link } from "react-router-dom";

export const MainContainer = styled(Link)`
  width: 24%;
  border-radius: 10px;
  background: #fafafa;
  cursor: pointer;
  position: relative;
  display: block;
  text-decoration: none;
  color: inherit;
  @media screen and (max-width: 768px) {
    width: 47%;
  }
`;

export const InnerContainer = styled.div`
  width: 90%;
  margin: 0 auto;
`;

export const ImageWrapper = styled.div`
  padding-top: 20px;
  width: 80%;
  margin: 0 auto;
  aspect-ratio: 1 / 1;
  overflow: hidden;
  @media screen and (max-width: 768px) {
    width: 70%;
    padding-top: 16px;
  }
`;

export const StyledImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover; /* crop & scale to fill */
  object-position: center;
  @media screen and (max-width: 768px) {
    width: 100%;
  }
`;

export const TitleWrapper = styled.div`
  margin-top: 16px;
  margin-bottom: 12px;
  @media screen and (max-width: 768px) {
    margin-top: 12px;
  }
`;

export const PriceWrapper = styled.div`
  display: flex;
`;

export const InnerPriceWrapper = styled.div`
  padding-bottom: 26px;
  display: flex;
  gap: 6px;
`;

export const PriceWrapperAfterLogin = styled.div`
  padding-bottom: 26px;
  display: flex;
  width: 65%;
  align-items: center;
  justify-content: space-between;
`;

export const MsrpPriceWrapper = styled.div`
  display: flex;
  gap: 6px;
`;

export const StyledTitle = styled.h3`
  color: #000;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
`;

export const StyledPrice = styled.span`
  color: #6b7280;
  font-family: Inter;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;

export const StyledPriceAfterLogin = styled.div`
  color: #000;
  font-family: Inter;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 153.846% */
`;
